import React, { useState } from "react";
import { Chart, registerables } from "chart.js";
// Components
import {
  GraphicContainer,
  GraphicRotateDiv,
  HeaderDiv,
  MaximizeGraphicButton,
  MaximizeGraphicImg,
  GraphicTitle,
  BetaTitle,
  AxisAndGraphicDiv,
  AxisYSizeDiv,
  AxisY,
  GraphicSizeDiv,
  AxisX,
} from "./styles";
// Assets
import MaximizeImg from "../../assets/ico_maximize_graphic.svg";
import MinimizeImg from "../../assets/ico_minimize_graphic.svg";

const Graphic = ({ Title, Type, data, axisY, axisX, max = false, isBeta = false, paramScales = false }) => {
  Chart.register(...registerables);
  const [maximizeActive, setMaximizeActive] = useState(false);
  const handleSetMaximizeActive = () => setMaximizeActive(!maximizeActive);

  const renderScales = () => {
    let defaultScales = {
      y: {
        beginAtZero: true,
      },
      x: {
        beginAtZero: true,
      },
    };
    let scales = paramScales ? paramScales : defaultScales;
    if (max) scales.y.max = max;
    return scales;
  };

  const shouldDisplayLegend = data?.datasets?.filter((ds) => ds.label)?.length > 1;

  return (
    <GraphicContainer maximizeGraphic={maximizeActive}>
      <GraphicRotateDiv maximizeGraphic={maximizeActive}>
        <HeaderDiv>
          <GraphicTitle>{Title}</GraphicTitle>
          {isBeta && <BetaTitle>Beta</BetaTitle>}
        </HeaderDiv>
        <MaximizeGraphicButton onClick={handleSetMaximizeActive}>
          <MaximizeGraphicImg src={maximizeActive ? MinimizeImg : MaximizeImg} alt="btn-max-min-graphic" maximizeGraphic={maximizeActive} />
        </MaximizeGraphicButton>
        <AxisAndGraphicDiv>
          <AxisYSizeDiv>
            <AxisY>{axisY}</AxisY>
          </AxisYSizeDiv>
          <GraphicSizeDiv>
            <Type
              data={data}
              options={{
                clip: false,
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: shouldDisplayLegend,
                    labels: {
                      usePointStyle: true,
                      pointStyle: "circle",
                      filter: (legendItem, chartData) => {
                        let entries = chartData.datasets.map((e) => e.label);
                        return entries.indexOf(legendItem.text) === legendItem.datasetIndex;
                      },
                    },
                  },
                  tooltip: {
                    callbacks: {
                      label: function (context) {
                        const value = context.raw;
                        return value ? value.toLocaleString() : "N/A";
                      },
                    },
                  },
                },
                scales: renderScales(),
              }}
            />
          </GraphicSizeDiv>
        </AxisAndGraphicDiv>
        <AxisX>{axisX}</AxisX>
      </GraphicRotateDiv>
    </GraphicContainer>
  );
};

export default Graphic;
